const finishMessage = {
    add_success: {
        'zh-tw': "新增成功",
        en: "Add Successful",
    },
    modify_success: {
        'zh-tw': "修改成功",
        en: "Modify Successful",
    },
    delete_success: {
        'zh-tw': "刪除成功",
        en: "Delete Successful",
    },
    add_failure: {
        'zh-tw': "新增失敗",
        en: "Add Failure",
    },
    modify_failure: {
        'zh-tw': "修改失敗",
        en: "Modify Failure",
    },
    delete_failure: {
        'zh-tw': "刪除失敗",
        en: "Delete Failure",
    },
    please_select_item: {
        'zh-tw': "請選擇",
        en: "Please select an item",
    },
    please_input_item: {
        'zh-tw': "請輸入",
        en: "Please select an item",
    },
    yes: {
        'zh-tw': "是",
        en: "Yes",
    },
    no: {
        'zh-tw': "否",
        en: "no",
    },
    open: {
        'zh-tw': "開啟",
        en: "Open",
    },
    close: {
        'zh-tw': "關閉",
        en: "Close",
    },
}
const receiveSerialStatusOptions = {
    expected: {
        'zh-tw': "預期",
        en: "Expected",
    },
    arrived: {
        'zh-tw': "已到館",
        en: "Arrived",
    },
    late: {
        'zh-tw': "延遲",
        en: "Late",
    },
    missing: {
        'zh-tw': "缺件",
        en: "Missing",
    },
    missing_never_received: {
        'zh-tw': "缺件（未收到）",
        en: "Missing (never received)",
    },
    missing_sold_out: {
        'zh-tw': "缺件（絕版）",
        en: "Missing (sold out)",
    },
    missing_damaged: {
        'zh-tw': "缺件（損壞）",
        en: "Missing (damaged)",
    },
    missing_lost: {
        'zh-tw': "缺件（遺失）",
        en: "Missing (lost)",
    },
    claimed: {
        'zh-tw': "已申報",
        en: "Claimed",
    },
    not_available: {
        'zh-tw': "無供應",
        en: "Not available",
    },
    delete: {
        'zh-tw': "刪除",
        en: "Delete",
    }

}

const serials_management = {
    'zh-tw': "連續性出版品設定",
    en: "Serials Management",
    children: {
        ...finishMessage,
        receive_serial: {
            'zh-tw': "點收期刊",
            en: "Receive Serial",
        },
        serials_management: {
            'zh-tw': "連續性出版品設定",
            en: "Serials Management",
        },
        add: {
            'zh-tw': "新增",
            en: "Add",
        },
        modify: {
            'zh-tw': "修改",
            en: "Modify",
        },
        edit: {
            'zh-tw': "編輯",
            en: "Edit",
        },
        delete: {
            'zh-tw': "刪除",
            en: "Delete",
        },
        submit: {
            'zh-tw': "送出",
            en: "Submit",
        },
        add_success: {
            'zh-tw': "新增成功",
            en: "Add Successful",
        },
        modify_success: {
            'zh-tw': "修改成功",
            en: "Modify Successful",
        },
        delete_success: {
            'zh-tw': "刪除成功",
            en: "Delete Successful",
        },
        add_failure: {
            'zh-tw': "新增失敗",
            en: "Add Failure",
        },
        modify_failure: {
            'zh-tw': "修改失敗",
            en: "Modify Failure",
        },
        delete_failure: {
            'zh-tw': "刪除失敗",
            en: "Delete Failure",
        },
        batch_delete: {
            'zh-tw': "多筆刪除",
            en: "Batch Delete",
        },
        bibTitle: {
            'zh-tw': "書目名稱",
            en: "Title",
        },
        bibliographic_title: {
            'zh-tw': "書目名稱",
            en: "Bibliographic Title",
        },
        vendor: {
            'zh-tw': "書商",
            en: "Vendor",
        },
        received_serial_number: {
            'zh-tw': "收到此出版品時",
            en: "When Received Serial Number",
        },
        irregular_issue: {
            'zh-tw': "出現不規則期刊",
            en: "When there is an irregular issue",
        },
        manual_record_change: {
            'zh-tw': "是否可以手動變更紀錄",
            en: "Can Manual Record Change?",
        },
        call_number: {
            'zh-tw': "索書號",
            en: "Call Number",
        },
        library: {
            'zh-tw': "分館",
            en: "Library",
        },
        public_note: {
            'zh-tw': "公開備註",
            en: "Public Note",
        },
        internal_note: {
            'zh-tw': "內部備註",
            en: "Internal Note",
        },
        subscriber_notification: {
            'zh-tw': "訂閱者通知",
            en: "Subscriber Notification",
        },
        shelving_location: {
            'zh-tw': "擺放位置",
            en: "Shelving Location",
        },
        grace_period: {
            'zh-tw': "寬限期",
            en: "Grace Period",
        },
        day: {
            'zh-tw': "天",
            en: "day",
        },
        first_issue_publication_date: {
            'zh-tw': "首次出版日期",
            en: "First Issue Publication Date",
        },
        frequency: {
            'zh-tw': "發行頻率",
            en: "Frequency",
        },
        subscription_length: {
            'zh-tw': "訂閱時長",
            en: "Subscription Length",
        },
        subscription_start_date: {
            'zh-tw': "訂閱開始日期",
            en: "Subscription Start Date",
        },
        subscription_end_date: {
            'zh-tw': "訂閱結束日期",
            en: "Subscription End Date",
        },
        numbering_pattern: {
            'zh-tw': "編號模式",
            en: "Numbering Pattern",
        },
        publication_date_template: {
            'zh-tw': "出版日期模板",
            en: "Publication Date Template",
        },
        select_bibliographic: {
            'zh-tw': "選擇書目",
            en: "Select Bibliographic",
        },
        create_item_record: {
            'zh-tw': "建立館藏記錄",
            en: "Create an Item Record",
        },
        do_not_create_item_record: {
            'zh-tw': "不建立館藏記錄",
            en: "Do Not Create an Item Record",
        },
        skip_issue_number: {
            'zh-tw': "跳過期號",
            en: "Skip Issue Number",
        },
        keep_issue_number: {
            'zh-tw': "保留期號",
            en: "Keep Issue Number",
        },
        create_new_item: {
            'zh-tw': "建立一個新的館藏",
            en: "Create a New Item",
        },
        do_not_create_new_item: {
            'zh-tw': "不建立新的館藏",
            en: "Do Not Create a New Item",
        },
        locale: {
            'zh-tw': "語系",
            en: "Locale",
        },
        issues: {
            'zh-tw': "期",
            en: "issues",
        },
        weeks: {
            'zh-tw': "週",
            en: "weeks",
        },
        months: {
            'zh-tw': "月",
            en: "months",
        },
        biblionumber: {
            'zh-tw': "編號",
            en: "Bibliography",
        },
    }
}
const serial_frequency_management = {
    'zh-tw': "刊期管理",
    en: "Issue Management",
    children: {
        add_success: {
            'zh-tw': "新增成功",
            en: "Add Successful",
        },
        modify_success: {
            'zh-tw': "修改成功",
            en: "Modify Successful",
        },
        delete_success: {
            'zh-tw': "刪除成功",
            en: "Delete Successful",
        },
        add_failure: {
            'zh-tw': "新增失敗",
            en: "Add Failure",
        },
        modify_failure: {
            'zh-tw': "修改失敗",
            en: "Modify Failure",
        },
        delete_failure: {
            'zh-tw': "刪除失敗",
            en: "Delete Failure",
        },
        serial_frequency_management: {
            'zh-tw': "刊期管理",
            en: "Issue Management",
        },
        description: {
            'zh-tw': "描述",
            en: "Description",
        },
        unit: {
            'zh-tw': "單位",
            en: "Unit",
        },
        issues_per_unit: {
            'zh-tw': "每單位期數",
            en: "Issues per Unit",
        },
        units_per_issue: {
            'zh-tw': "每期單位數",
            en: "Units per Issue",
        },
        display_order: {
            'zh-tw': "顯示順序",
            en: "Display Order",
        },
        please_enter: {
            'zh-tw': "請輸入",
            en: "Please Enter",
        },
        please_select: {
            'zh-tw': "請選擇",
            en: "Please Select",
        },
        note_one_field_must_be_one: {
            'zh-tw': "注意：以下兩個欄位之一必須等於 1",
            en: "Note: One of the following two fields must equal 1",
        }
    }
}
const serial_code_management = {
    'zh-tw': "期刊編碼管理",
    en: "Serial Code Management",
    children: {
        add_success: {
            'zh-tw': "新增成功",
            en: "Add Successful",
        },
        modify_success: {
            'zh-tw': "修改成功",
            en: "Modify Successful",
        },
        delete_success: {
            'zh-tw': "刪除成功",
            en: "Delete Successful",
        },
        add_failure: {
            'zh-tw': "新增失敗",
            en: "Add Failure",
        },
        modify_failure: {
            'zh-tw': "修改失敗",
            en: "Modify Failure",
        },
        delete_failure: {
            'zh-tw': "刪除失敗",
            en: "Delete Failure",
        },
        name: {
            'zh-tw': "名稱",
            en: "Name",
        },
        description: {
            'zh-tw': "描述",
            en: "Description",
        },
        numbering_formula: {
            'zh-tw': "編號公式",
            en: "Numbering Formula",
        },
        display_order: {
            'zh-tw': "顯示順序",
            en: "Display Order",
        },
        label: {
            'zh-tw': "標籤",
            en: "Label",
        },
        add: {
            'zh-tw': "增加",
            en: "Add",
        },
        every: {
            'zh-tw': "每經過幾期",
            en: "Every",
        },
        set_back_to: {
            'zh-tw': "設定回",
            en: "Set Back to",
        },
        when_more_than: {
            'zh-tw': "當超過",
            en: "When More Than",
        },
        formatting: {
            'zh-tw': "格式化文字",
            en: "Formatting",
        },
        preview_code_settings_display: {
            'zh-tw': "預覽編碼設定呈現",
            en: "Preview Code Settings Display",
        },
        serial_code_setting: {
            'zh-tw': "編碼設定",
            en: "Serial Code Setting"
        },
        first_issue_publication_date: {
            'zh-tw': "首次出版日期",
            en: "First Issue Publication Date",
        },
        frequency: {
            'zh-tw': "發行頻率",
            en: "Frequency",
        },
        subscription_length: {
            'zh-tw': "訂閱時長",
            en: "Subscription Length",
        },
        begins_with: {
            'zh-tw': "開始於",
            en: "Begins With",
        },
        inner_counter: {
            'zh-tw': "內部計數器",
            en: "Inner Counter",
        },
        number: {
            'zh-tw': "編號",
            en: "Number",
        },
        publication_date: {
            'zh-tw': "出版日期",
            en: "Publication Date",
        },
        generate_preview: {
            'zh-tw': "產生預覽",
            en: "Generate Preview",
        },

        name_of_day: {
            'zh-tw': "星期名稱",
            en: "Name of Day",
        },
        name_of_day_abbreviated: {
            'zh-tw': "星期名稱（縮寫）",
            en: "Name of Day (Abbreviated)",
        },
        name_of_month: {
            'zh-tw': "月份名稱",
            en: "Name of Month",
        },
        name_of_month_abbreviated: {
            'zh-tw': "月份名稱（縮寫）",
            en: "Name of Month (Abbreviated)",
        },
        name_of_season: {
            'zh-tw': "季節名稱",
            en: "Name of Season",
        },
        name_of_season_abbreviated: {
            'zh-tw': "季節名稱（縮寫）",
            en: "Name of Season (Abbreviated)",
        },
        locale: {
            'zh-tw': "語系",
            en: "Locale",
        },
        please_select: {
            'zh-tw': "請選擇",
            en: "Please Select",
        },
        please_enter: {
            'zh-tw': "請輸入",
            en: "Please Enter",
        },
    }
}
const add_record = {
    'zh-tw': "新增書目",
    en: "Add Record",
    children: {
        type_of_material: {
            'zh-tw': "資料類型",
            en: "Type of Material",
        },
        date_entered_on_file: {
            'zh-tw': "（00-05）檔案登錄日期",
            en: " （00-05）Date Entered on File",
        },
        type_of_date_publication_status: {
            'zh-tw': "（06）出版情況",
            en: "Type of Date/Publication Status （06）",
        },
        date_1: {
            'zh-tw': "（07-10） 第一出版年",
            en: "（07-10）Date 1 ",
        },
        date_2: {
            'zh-tw': "（11-14）第二出版年",
            en: "（11-14）Date 2 ",
        },
        place_of_publication: {
            'zh-tw': "（15-17）出版地區",
            en: "（15-17）Place of Publication Code ",
        },
        illustrations_code_1: {
            'zh-tw': "（18）插圖代碼 1",
            en: "（18）Illustrations - Code 1 ",
        },
        illustrations_code_2: {
            'zh-tw': "（19）插圖代碼 2",
            en: "（19）Illustrations - Code 2 ",
        },
        illustrations_code_3: {
            'zh-tw': "（20）插圖代碼 3",
            en: "（20）Illustrations - Code 3 ",
        },
        illustrations_code_4: {
            'zh-tw': "（21）插圖代碼 4",
            en: "（21）Illustrations - Code 4 ",
        },
        target_audience: {
            'zh-tw': "（22）適用對象",
            en: "（22）Target Audience ",
        },
        form_of_item: {
            'zh-tw': "（23） 形式特性",
            en: "（23）Form of Item ",
        },
        nature_of_contents_code_1: {
            'zh-tw': "（24）內容形式 1",
            en: "（24）Nature of Contents - Code 1",
        },
        nature_of_contents_code_2: {
            'zh-tw': "（25）內容形式 2",
            en: "（25）Nature of Contents - Code 2 ",
        },
        nature_of_contents_code_3: {
            'zh-tw': "（26）內容形式 3",
            en: "（26）Nature of Contents - Code 3 ",
        },
        nature_of_contents_code_4: {
            'zh-tw': "（27）內容形式 4",
            en: "（27）Nature of Contents - Code 4 ",
        },
        government_publication: {
            'zh-tw': "（28）政府出版品",
            en: "（28）Government Publication ",
        },
        conference_publication: {
            'zh-tw': "（29）會議出版品代碼",
            en: "（29）Conference Publication ",
        },
        festschrift: {
            'zh-tw': "（30）紀念集指標",
            en: "（30）Festschrift ",
        },
        index: {
            'zh-tw': "（31）索引",
            en: "（31）Index ",
        },
        undefined: {
            'zh-tw': "（32）未定義",
            en: "（32）Undefined ",
        },
        literary_form: {
            'zh-tw': "（33）文學體裁代碼 ",
            en: "（33）Literary Form ",
        },
        biography: {
            'zh-tw': "（34）傳記代碼",
            en: "（34）Biography ",
        },
        language: {
            'zh-tw': "（35-37）語言",
            en: "（35-37）Language ",
        },
        modified_record: {
            'zh-tw': "（38）已修改的紀錄",
            en: "（38）Modified Record ",
        },
        cataloging_source: {
            'zh-tw': "（39）編目來源",
            en: "（39）Cataloging Source ",
        },
        //CF
        undefined_18_21: {
            'zh-tw': "(18-21) 未定義",
            en: "(18-21) Undefined",
        },
        target_audience_22: {
            'zh-tw': "(22) 目標受眾",
            en: "(22) Target Audience",
        },
        form_of_item_23: {
            'zh-tw': "(23) 資料形式",
            en: "(23) Form of Item",
        },
        undefined_24_25: {
            'zh-tw': "(24-25) 未定義",
            en: "(24-25) Undefined",
        },
        type_of_computer_file_26: {
            'zh-tw': "(26) 電腦檔案類型",
            en: "(26) Type of Computer File",
        },
        undefined_27: {
            'zh-tw': "(27) 未定義",
            en: "(27) Undefined",
        },
        government_publication_28: {
            'zh-tw': "(28) 政府出版品",
            en: "(28) Government Publication",
        },
        undefined_29_34: {
            'zh-tw': "(29-34) 未定義",
            en: "(29-34) Undefined",
        },

        //CR
        frequency_18: {
            'zh-tw': "(18) 頻率",
            en: "(18) Frequency",
        },
        regularity_19: {
            'zh-tw': "(19) 規律性",
            en: "(19) Regularity",
        },
        undefined_20: {
            'zh-tw': "(20) 未定義",
            en: "(20) Undefined",
        },
        type_of_continuing_resource_21: {
            'zh-tw': "(21) 持續資源類型",
            en: "(21) Type of Continuing Resource",
        },
        form_of_original_item_22: {
            'zh-tw': "(22) 原始項目形式",
            en: "(22) Form of Original Item",
        },

        nature_of_entire_work_24: {
            'zh-tw': "(24) 整體作品性質",
            en: "(24) Nature of Entire Work",
        },
        nature_of_contents_25_27: {
            'zh-tw': "(25-27) 內容性質",
            en: "(25-27) Nature of Contents",
        },

        conference_publication_29: {
            'zh-tw': "(29) 會議出版品",
            en: "(29) Conference Publication",
        },
        undefined_30_32: {
            'zh-tw': "(30-32) 未定義",
            en: "(30-32) Undefined",
        },
        original_alphabet_or_script_of_title_33: {
            'zh-tw': "(33) 標題的原始字母或文字",
            en: "(33) Original Alphabet or Script of Title",
        },
        entry_convention_34: {
            'zh-tw': "(34) 進入慣例",
            en: "(34) Entry Convention",
        },
        //MP
        relief_18_21: {
            'zh-tw': "(18-21) 地形",
            en: "(18-21) Relief",
        },
        projection_22_23: {
            'zh-tw': "(22-23) 投影",
            en: "(22-23) Projection",
        },
        undefined_24: {
            'zh-tw': "(24) 未定義",
            en: "(24) Undefined",
        },
        type_of_cartographic_material_25: {
            'zh-tw': "(25) 製圖材料的類型",
            en: "(25) Type of Cartographic Material",
        },
        undefined_26_27: {
            'zh-tw': "(26-27) 未定義",
            en: "(26-27) Undefined",
        },
        form_of_item_29: {
            'zh-tw': "(29) 資料形式",
            en: "(29) Form of Item",
        },
        undefined_30: {
            'zh-tw': "(30) 未定義",
            en: "(30) Undefined",
        },
        index_31: {
            'zh-tw': "(31) 索引",
            en: "(31) Index",
        },
        undefined_32: {
            'zh-tw': "(32) 未定義",
            en: "(32) Undefined",
        },
        special_format_characteristics_33_34: {
            'zh-tw': "(33-34) 特殊格式特徵",
            en: "(33-34) Special Format Characteristics",
        },
        //MU
        form_of_composition_18_19: {
            'zh-tw': "(18-19) 作曲形式",
            en: "(18-19) Form of Composition",
        },
        format_of_music_20: {
            'zh-tw': "(20) 音樂格式",
            en: "(20) Format of Music",
        },
        music_parts_21: {
            'zh-tw': "(21) 音樂部分",
            en: "(21) Music Parts",
        },

        accompanying_matter_24_29: {
            'zh-tw': "(24-29) 附加資料",
            en: "(24-29) Accompanying Matter",
        },
        literary_text_for_sound_recordings_30_31: {
            'zh-tw': "(30-31) 聲音錄製的文學文本",
            en: "(30-31) Literary Text for Sound Recordings",
        },

        transposition_and_arrangement_33: {
            'zh-tw': "(33) 調性變換與編排",
            en: "(33) Transposition and Arrangement",
        },
        undefined_34: {
            'zh-tw': "(34) 未定義",
            en: "(34) Undefined",
        },
        //MX
        undefined_18_22: {
            'zh-tw': "(18-22) 未定義",
            en: "(18-22) Undefined",
        },
        undefined_24_34: {
            'zh-tw': "(24-34) 未定義",
            en: "(24-34) Undefined",
        },
        //VM
        running_time_18_20: {
            'zh-tw': "(18-20) 電影和錄影資料的片長",
            en: "(18-20) Running time for motion pictures and videorecordings",
        },
        undefined_21: {
            'zh-tw': "(21) 未定義",
            en: "(21) Undefined",
        },

        undefined_23_27: {
            'zh-tw': "(23-27) 未定義",
            en: "(23-27) Undefined",
        },
        type_of_visual_material_33: {
            'zh-tw': "(33) 視覺材料類型",
            en: "(33) Type of visual material",
        },
        technique_34: {
            'zh-tw': "(34) 技術",
            en: "(34) Technique",
        },
        add_fixed_field: {
            'zh-tw': "新增定長欄",
            en: "Add Fixed Field",
        },
        delete_fixed_field: {
            'zh-tw': "刪除定長欄",
            en: "Delete Fixed Field",
        },
        add_variable_field: {
            'zh-tw': "新增變長欄",
            en: "Add Variable Field",
        },
        delete_variable_field: {
            'zh-tw': "刪除變長欄",
            en: "Delete Variable Field",
        },
        add_subfield: {
            'zh-tw': "新增分欄",
            en: "Add Subfield",
        },
        delete_subfield: {
            'zh-tw': "刪除分欄",
            en: "Delete Subfield",
        },
    }
}
const edit_record = {
    'zh-tw': "編輯書目",
    en: "Edit Record",
    children: {

    }
}
const framework_management = {
    'zh-tw': "MARC 框架管理",
    en: "Framework Management",
    children: {
        ...finishMessage,
        frameworkcode: {
            'zh-tw': "框架代碼",
            en: "Framework Code",
        },
        frameworktext: {
            'zh-tw': "框架描述",
            en: "Description",
        },
        edit_field: {
            'zh-tw': "編輯欄位",
            en: "Edit Field",
        },
        framework_code_limit: {
            'zh-tw': "框架代碼最多4個字元",
            en: "Framework code limit is 4 characters max",
        },
        default_framework_locked: {
            'zh-tw': "Default framework 不可進行修改",
            en: "Default framework cannot be modified",
        }
    }
}
const tag_structure_management = {
    'zh-tw': "書目架構欄位管理",
    en: "MARC Bibliographic Framework Management",
    children: {
        ...finishMessage,
        tagfield: {
            'zh-tw': "標籤欄位",
            en: "Tag Field",
        },
        liblibrarian: {
            'zh-tw': "館員介面顯示",
            en: "Display in Librarian Interface",
        },
        libopac: {
            'zh-tw': "OPAC顯示",
            en: "Display in OPAC",
        },
        repeatable: {
            'zh-tw': "可重複",
            en: "Repeatable",
        },
        mandatory: {
            'zh-tw': "必填",
            en: "Mandatory",
        },
        important: {
            'zh-tw': "重要",
            en: "Important",
        },
        authorised_value: {
            'zh-tw': "授權值",
            en: "Authorised Value",
        },
        ind1_defaultvalue: {
            'zh-tw': "指標1的預設值",
            en: "Default Value for Indicator 1",
        },
        ind2_defaultvalue: {
            'zh-tw': "指標2的預設值",
            en: "Default Value for Indicator 2",
        },
        frameworkcode: {
            'zh-tw': "框架代碼",
            en: "Framework Code",
        },
        indicator_value_limit: {
            'zh-tw': "如果在此選擇一個值，指標將限制為授權值清單中的選項。",
            en: "If you select a value here, the indicators will be limited to the authorized value list.",
        },
        marc_bibliographic_framework: {
            'zh-tw': "MARC 書目架構 ",
            en: "MARC bibliographic framework ",
        },
        edit_subfield: {
            'zh-tw': "編輯分欄",
            en: "Edit Subfield",
        },
        total_columns: {
            'zh-tw': "分欄總數",
            en: "Total Columns",
        },
        create_framework_method: {
            'zh-tw': "使用以下方式建立框架",
            en: "Create framework using the following method",
        },
        confirm: {
            'zh-tw': "確定",
            en: "Confirm",
        },
        add_using_framework: {
            'zh-tw': "使用此框架進行新增",
            en: "Add using this framework",
        }
    }
}
const subfield_structure_management = {
    'zh-tw': "欄位分欄管理",
    en: "Subfield Structure Management",
    children: {
        ...finishMessage,

        tagsubfield: {
            'zh-tw': "子欄位標籤",
            en: "Tag Subfield",
        },
        tagfield: {
            'zh-tw': "標籤欄位",
            en: "Tag Field",
        },
        frameworkcode: {
            'zh-tw': "框架代碼",
            en: "Framework Code",
        },
        liblibrarian: {
            'zh-tw': "說明",
            en: "Display in Librarian Interface",
        },
        libopac: {
            'zh-tw': "OPAC 說明",
            en: "Display in OPAC Interface",
        },
        repeatable: {
            'zh-tw': "可重複",
            en: "Repeatable",
        },
        mandatory: {
            'zh-tw': "必填",
            en: "Mandatory",
        },
        important: {
            'zh-tw': "重要",
            en: "Important",
        },
        kohafield: {
            'zh-tw': "Koha 欄位",
            en: "Koha Field",
        },
        tab: {
            'zh-tw': "頁籤",
            en: "Tab",
        },
        authorised_value: {
            'zh-tw': "授權值",
            en: "Authorized Value",
        },
        authtypecode: {
            'zh-tw': "權威類型代碼",
            en: "Auth Type Code",
        },
        value_builder: {
            'zh-tw': "值生成器",
            en: "Value Builder",
        },
        isurl: {
            'zh-tw': "是否為 URL",
            en: "Is URL",
        },
        seealso: {
            'zh-tw': "參見",
            en: "See Also",
        },
        LINK: {
            'zh-tw': "鏈接",
            en: "Link",
        },
        defaultvalue: {
            'zh-tw': "預設值",
            en: "Default Value",
        },
        maxlength: {
            'zh-tw': "最大長度",
            en: "Max Length",
        },
        display_order: {
            'zh-tw': "顯示順序",
            en: "Display Order",
        },
        key: {
            'zh-tw': "鍵值",
            en: "Key",
        },
        hidden_opac: {
            'zh-tw': "在 OPAC 中隱藏",
            en: "Hidden in OPAC",
        },
        hidden_staff_interface: {
            'zh-tw': "在職員界面中隱藏",
            en: "Hidden in Staff Interface",
        },
        hidden_editor: {
            'zh-tw': "在編輯器中隱藏",
            en: "Hidden in Editor",
        },
        hidden_collapsed: {
            'zh-tw': "折疊隱藏",
            en: "Hidden Collapsed",
        },
        hidden_flagged: {
            'zh-tw': "標記隱藏",
            en: "Hidden Flagged",
        },
        ignore: {
            'zh-tw': "忽略",
            en: "Ignore",
        },
        ignore_message: {
            'zh-tw': "忽略表示子欄位不會顯示在記錄編輯器中，並且其值（如果有的話）將從記錄中刪除。",
            en: "Ignore means that the subfield does not display in the record editor and that its value, if any, is deleted from the record.",
        },
        basic_constraints: {
            'zh-tw': "基本限制",
            en: "Basic constraints",
        },
        advanced_constraints: {
            'zh-tw': "進階限制",
            en: "Advanced constraints",
        },
        other_options_choose_one: {
            'zh-tw': "其他選項（擇一）",
            en: "Other options (choose one)",
        },
        if_checked_subfield_is_url_clickable: {
            'zh-tw': "如果勾選，則表示該子欄位是一個URL，可以點選",
            en: "If checked, the subfield is a URL and can be clicked",
        },
        index_name_example: {
            'zh-tw': "索引名稱，例如標題或本地號碼",
            en: "Index name, such as title or local number",
        },
        edit_koha_to_marc_mapping: {
            'zh-tw': "在「Koha 到 MARC 對應」中編輯",
            en: "Edit in 'Koha to MARC mapping'",
        },

    }
}
const serial_receive = {
    'zh-tw': "期刊點收",
    en: "Serial Receive",
    children: {
        ...finishMessage,
        ...receiveSerialStatusOptions,
        sort_hint: {
            'zh-tw': "預設依期刊名稱排序，同一期刊依期刊序號由新到舊排列，點選欄位標頭可調整排序。",
            en: "Serials are sorted by title by default, then by serial sequence from newest to oldest within each title. Click a column header to change the sort order.",
        },
        biblionumber: {
            'zh-tw': "書目編號",
            en: "Biblio Number",
        },
        claimdate: {
            'zh-tw': "索賠日期",
            en: "Claim Date",
        },
        claims_count: {
            'zh-tw': "索賠次數",
            en: "Claims Count",
        },
        notes: {
            'zh-tw': "備註",
            en: "Notes",
        },
        planneddate: {
            'zh-tw': "到刊日期",
            en: "Planned Date",
        },
        publisheddate: {
            'zh-tw': "出版日期",
            en: "Published Date",
        },
        publisheddatetext: {
            'zh-tw': "出版日期（文字）",
            en: "Published Date (Text)",
        },
        routingnotes: {
            'zh-tw': "傳閱備註",
            en: "Routing Notes",
        },
        serialid: {
            'zh-tw': "期刊ID",
            en: "Serial ID",
        },
        serialseq: {
            'zh-tw': "期刊序號",
            en: "Serial Sequence",
        },
        serialseq_x: {
            'zh-tw': "期刊序號 X",
            en: "Serial Sequence X",
        },
        serialseq_y: {
            'zh-tw': "期刊序號 Y",
            en: "Serial Sequence Y",
        },
        serialseq_z: {
            'zh-tw': "期刊序號 Z",
            en: "Serial Sequence Z",
        },
        status: {
            'zh-tw': "狀態",
            en: "Status",
        },
        subscriptionid: {
            'zh-tw': "訂閱ID",
            en: "Subscription ID",
        },
        serial: {
            'zh-tw': "期刊名稱",
            en: "Serial",
        },
        bib_title: {
            'zh-tw': "書目名稱",
            en: "bib Title",
        },
        time_start: {
            'zh-tw': "開始日期",
            en: "time start",
        },
        time_end: {
            'zh-tw': "結束日期",
            en: "time end",
        },
        collection_information: {
            'zh-tw': "館藏資訊",
            en: "Collection Information"
        },
        journal_collection_added_quantity: {
            'zh-tw': "期刊館藏新增數量",
            en: "Journal Collection Added Quantity"
        }
    }
}
const serial_orderlist_management = {
    'zh-tw': "期刊訂單管理",
    en: "Journal Order Management",
    children: {
        ...finishMessage,
        order_number: {
            'zh-tw': "訂單編號",
            en: "Order Number"
        },
        name: {
            'zh-tw': "訂單名稱",
            en: "Name"
        },
        creator: {
            'zh-tw': "建立人",
            en: "Creator"
        },
        creation_time: {
            'zh-tw': "建立時間",
            en: "Creation Time"
        },
        order_time_period: {
            'zh-tw': "訂單時間區段",
            en: "Order Time Period"
        },
        journal_item_quantity: {
            'zh-tw': "期刊項目數量",
            en: "Journal Item Quantity"
        },
        receivable_within_one_month: {
            'zh-tw': "前往點收",
            en: "Receivable Within One Month"
        },
        order_information: {
            'zh-tw': "訂單資訊",
            en: "Order Information"
        },
        journal_list: {
            'zh-tw': "期刊列表",
            en: "Journal List"
        },
        order_basic_information: {
            'zh-tw': "訂單基本資料",
            en: "Order Basic Information"
        },
        save: {
            'zh-tw': "儲存",
            en: "Save"
        },
        cancel: {
            'zh-tw': "取消",
            en: "Cancel"
        },
        time_start: {
            'zh-tw': "開始日期",
            en: "time start",
        },
        time_end: {
            'zh-tw': "結束日期",
            en: "time end",
        },
        auto_fill_on_completion: {
            'zh-tw': "新增完成時將自動帶入",
            en: "Will be automatically filled upon completion"
        },
        operation: {
            'zh-tw': "操作",
            en: "Operation"
        },
        renew_journal_reminder: {
            'zh-tw': "續訂期刊提醒",
            en: "Journal Renewal Reminder",
        },
        renew_journal_message: {
            'zh-tw': "提醒您，續訂功能將直接帶入舊有訂單設定資訊，請務必調整期刊訂閱日期，避免新增錯誤",
            en: "Reminder: The renewal function will carry over the previous order settings. Please adjust the subscription dates to avoid errors.",
        },
        renew_subscription: {
            'zh-tw': "續訂",
            en: "Renew Subscription",
        },
        ...serials_management?.children,

    }
}
const scrapped_list_management = {
    'zh-tw': "館藏報廢管理",
    en: "Collection Disposal Management",
    children: {
        ...finishMessage,
        item_serial_issue_number: {
            'zh-tw': "冊數",
            en: "serial_issue",
        },
        order_number: {
            'zh-tw': "訂單編號",
            en: "Order Number"
        },
        name: {
            'zh-tw': "訂單名稱",
            en: "Name"
        },
        creator: {
            'zh-tw': "建立人",
            en: "Creator"
        },
        creation_time: {
            'zh-tw': "建立時間",
            en: "Creation Time"
        },
        order_time_period: {
            'zh-tw': "訂單時間區段",
            en: "Order Time Period"
        },
        journal_item_quantity: {
            'zh-tw': "期刊項目數量",
            en: "Journal Item Quantity"
        },
        receivable_within_one_month: {
            'zh-tw': "一月內可點收",
            en: "Receivable Within One Month"
        },
        order_information: {
            'zh-tw': "訂單資訊",
            en: "Order Information"
        },
        journal_list: {
            'zh-tw': "期刊列表",
            en: "Journal List"
        },
        order_basic_information: {
            'zh-tw': "訂單基本資料",
            en: "Order Basic Information"
        },
        save: {
            'zh-tw': "儲存",
            en: "Save"
        },
        cancel: {
            'zh-tw': "取消",
            en: "Cancel"
        },
        disposal_reason: {
            'zh-tw': "報廢原因",
            en: "Disposal Reason"
        },
        disposal_status: {
            'zh-tw': "報廢狀態",
            en: "Disposal Status"
        },
        disposal_collection_quantity: {
            'zh-tw': "報廢館藏數量",
            en: "Disposal Collection Quantity"
        },
        list_information: {
            'zh-tw': "清單資訊",
            en: "List Information"
        },
        collection_list: {
            'zh-tw': "館藏列表",
            en: "Collection List"
        },
        Item_type: {
            'zh-tw': "館藏類型",
            en: "Item type"
        },
        "Current library": {
            'zh-tw': "現行圖書館",
            en: "Current library"
        },
        "Home library": {
            'zh-tw': "所屬分館",
            en: "Home library"
        },
        "Call_number": {
            'zh-tw': "索書號",
            en: "Call Number"
        },
        "Status": {
            'zh-tw': "狀態",
            en: "Status"
        },
        "Last seen": {
            'zh-tw': "最後一次查看",
            en: "Last seen"
        },
        "Date accessioned": {
            'zh-tw': "建立日期",
            en: "Accession date"
        },
        "Date last borrowed": {
            'zh-tw': "最後一次借出",
            en: "Last borrowed"
        },
        "Copy number": {
            'zh-tw': "複本號",
            en: "Copy number"
        },
        withdrawn_status: {
            'zh-tw': "停用狀態",
            en: "Withdrawn Status",
        },
        Barcode: {
            'zh-tw': "條碼",
            en: "Barcode"
        },
        "CanCheckout": {
            'zh-tw': "可借出",
            en: "Can Checkout"
        },
        "CantCheckout": {
            'zh-tw': "借出中",
            en: "Can't Checkout"
        },
        book_title: {
            'zh-tw': "書名",
            en: "Book Title"
        },
        successfully_added_collection_item: {
            'zh-tw': "成功新增館藏項目",
            en: "Successfully added collection item"
        },
        scanned_collection_barcode: {
            'zh-tw': "已掃描館藏條碼",
            en: "Scanned collection barcode"
        },
        collection_item_not_found: {
            'zh-tw': "找不到館藏項目",
            en: "Collection item not found"
        },
        add: {
            'zh-tw': "新增",
            en: "Add",
        },

        select_from_existing_collections: {
            'zh-tw': "從現有館藏選擇",
            en: "Select from existing collections"
        },
        manual_input: {
            'zh-tw': "手動輸入",
            en: "Manual Input"
        },
        confirm_selection: {
            'zh-tw': "確認選擇",
            en: "Confirm Selection"
        },
        barcode_scan_instruction: {
            'zh-tw': "請使用條碼掃描器掃描館藏條碼，或直接輸入條碼後按下新增按鈕",
            en: "Please use a barcode scanner to scan the collection barcode, or enter the barcode manually and press the add button."
        },
        scan_or_enter_barcode: {
            'zh-tw': "掃描或輸入條碼....",
            en: "Scan or enter barcode...."
        },
        barcode: {
            'zh-tw': "條碼",
            en: "Barcode"
        },
        confirm_scan: {
            'zh-tw': "確認掃碼",
            en: "Confirm Scan"
        },
        already_scanned: {
            'zh-tw': "已經掃描過了",
            en: "Already scanned"
        },
        add_detail: {
            'zh-tw': "新增明細",
            en: "Add Detail"
        },
        operation: {
            'zh-tw': "操作",
            en: "Operation"
        },
        bib_author: {
            'zh-tw': "作者",
            en: "Author",
        },
        bib_publisher: {
            'zh-tw': "出版社",
            en: "Publisher",
        },
        saving_message: {
            'zh-tw': "請稍候，正在儲存中...",
            en: "Please wait, saving...",
        },
    }
}
const bibliographic_management = {
    'zh-tw': "書目管理",
    en: "Bibliographic Management",
    children: {
        ...finishMessage,
        general_bibliographic_edit_mode: {
            'zh-tw': "書目一般編輯模式",
            en: "General Bibliographic Edit Mode",
        },
        bib_biblionumber: {
            'zh-tw': "書目編號",
            en: "Bibliographic Number",
        },
        bib_notes: {
            'zh-tw': "書目備註",
            en: "Bibliographic Notes",
        },
        bib_copyrightdate: {
            'zh-tw': "版權日期",
            en: "Copyright Date",
        },
        bib_datecreated: {
            'zh-tw': "建立日期",
            en: "Date Created",
        },
        bib_seriestitle: {
            'zh-tw': "系列標題",
            en: "Series Title",
        },
        bibitem_biblioitemnumber: {
            'zh-tw': "書目項目編號",
            en: "Bibliographic Item Number",
        },
        bibitem_volume: {
            'zh-tw': "卷冊",
            en: "Volume",
        },
        bibitem_itemtype: {
            'zh-tw': "館藏類型",
            en: "Item Type",
        },
        bibitem_itemtype_description: {
            'zh-tw': "館藏類型描述",
            en: "Item Type Description",
        },
        bibitem_isbn: {
            'zh-tw': "ISBN",
            en: "ISBN",
        },
        bibitem_publishercode: {
            'zh-tw': "出版商代碼",
            en: "Publisher Code",
        },
        bibitem_editionstatement: {
            'zh-tw': "版本說明",
            en: "Edition Statement",
        },
        bibitem_illus: {
            'zh-tw': "插圖",
            en: "Illustrations",
        },
        bibitem_pages: {
            'zh-tw': "頁數",
            en: "Pages",
        },
        bibitem_notes: {
            'zh-tw': "館藏備註",
            en: "Item Notes",
        },
        bibitem_size: {
            'zh-tw': "尺寸",
            en: "Size",
        },
        bibitem_place: {
            'zh-tw': "出版地",
            en: "Place of Publication",
        },
        bib_cover_images: {
            'zh-tw': "封面圖片",
            en: "Cover Images",
        },
        items_count: {
            'zh-tw': "館藏數量",
            en: "Number of Copies",
        },
        items_borrowed_count: {
            'zh-tw': "借閱數量",
            en: "Number of Borrowed Copies",
        },
        metadata: {
            'zh-tw': "中繼資料",
            en: "Metadata",
        },
        rank: {
            'zh-tw': "排名",
            en: "Rank",
        },
        key: {
            'zh-tw': "鍵值",
            en: "Key",
        },
        bib_materialtype: {
            'zh-tw': "資料類型",
            en: "Material Type",
        },
        bib_format: {
            'zh-tw': "格式",
            en: "Format",
        },
        bib_targetaudience: {
            'zh-tw': "目標讀者",
            en: "Target Audience",
        },
        bib_literaryform: {
            'zh-tw': "文學形式",
            en: "Literary Form",
        },
        bib_title: {
            'zh-tw': "書名",
            en: "Title",
        },
        bib_othertitle: {
            'zh-tw': "其他書名",
            en: "Other Title",
        },
        bib_author: {
            'zh-tw': "作者",
            en: "Author",
        },
        bib_translator: {
            'zh-tw': "譯者",
            en: "Translator",
        },
        bib_language: {
            'zh-tw': "語言",
            en: "Language",
        },
        bib_publisher: {
            'zh-tw': "出版社",
            en: "Publisher",
        },
        bib_view_times: {
            'zh-tw': "瀏覽次數",
            en: "View Count",
        },
        bib_borrow_times: {
            'zh-tw': "借閱次數",
            en: "Borrow Count",
        }

    }
}
const budget_and_quantity_control = {
    'zh-tw': "經費與建構數量控制",
    en: "Budget and Quantity Control",
    children: {
        ...finishMessage,
        patch: {
            'zh-tw': "",
            en: "",
        },
        submit: {
            'zh-tw': "送出",
            en: "Submit",
        },
        cancel: {
            'zh-tw': "取消",
            en: "Cancel",
        },
        data: {
            'zh-tw': "經費與建構數量控制",
            en: "Budget and Quantity Control",
        },
        fiscal_year: {
            'zh-tw': "年度",
            en: "Fiscal Year",
        },
        estimated_expense: {
            'zh-tw': "預計花費",
            en: "Estimated Expense",
        },
        actual_expense: {
            'zh-tw': "實際花費",
            en: "Actual Expense",
        },
        remaining_budget: {
            'zh-tw': "剩餘經費",
            en: "Remaining Budget",
        },
        personal_recommendation_quota: {
            'zh-tw': "每人薦購配額",
            en: "Personal Recommendation Quota",
        },
        annual_budget_overview: {
            'zh-tw': "年度預算概況",
            en: "Annual Budget Overview",
        },
        add_new: {
            'zh-tw': "新增",
            en: "Add New",
        },
        edit: {
            'zh-tw': "編輯",
            en: "Edit",
        },
        usage_rate: {
            'zh-tw': "使用率",
            en: "Usage Rate",
        },

    }
}
const duplicate_check = {
    'zh-tw': "複本查核",
    en: "Duplicate Check",
    children: {

    }
}
const book_image_upload = {
    'zh-tw': "書目圖片上傳",
    en: "Book Image Upload",
    children: {

    }
}
const total_holdings = {
    'zh-tw': "館藏總量",
    en: "Total Holdings",
    children: {
        total_holdings: {
            'zh-tw': "館藏總量",
            en: "Total Holdings",
        },
        service_branch: {
            'zh-tw': "服務分館",
            en: "Service Branch",
        },
        growth_rate: {
            'zh-tw': "成長率",
            en: "Growth Rate",
        }
    }
}
const holdings_added = {
    'zh-tw': "館藏增加量",
    en: "Holdings Added",
    children: {

    }
}
const holdings_removed = {
    'zh-tw': "館藏淘汰量",
    en: "Holdings Removed",
    children: {

    }
}
const serials_checkin_statistics = {
    'zh-tw': "期刊點收統計",
    en: "Serials Check-in Statistics",
    children: {

    }
}
const acquisition_analysis = {
    'zh-tw': "館藏採購分析",
    en: "Acquisition Analysis",
    children: {

    }
}
const bibliographic_records = {
    'zh-tw': "書目紀錄",
    en: "Bibliographic Records",
    children: {

    }
}
const bibliographic_reviews = {
    'zh-tw': "書目評論",
    en: "Bibliographic Reviews",
    children: {

    }
}

const language_cataloging = {
    'zh-tw': "編目模組",
    en: "Cataloging Module",
    children: {
        serials_management: serials_management,
        serial_frequency_management: serial_frequency_management,
        serial_code_management: serial_code_management,
        AddMARC: {
            ...add_record,

        },
        EditMARC: {
            ...edit_record,
        },
        framework_management,
        tag_structure_management,
        subfield_structure_management,
        serial_receive,
        serial_orderlist_management,
        scrapped_list_management,
        bibliographic_management,
        budget_and_quantity_control,
        duplicate_check,
        book_image_upload,
        total_holdings,
        holdings_added,
        holdings_removed,
        serials_checkin_statistics,
        acquisition_analysis,
        bibliographic_records,
        bibliographic_reviews
    }
}

export { language_cataloging }